module.exports = __webpack_public_path__ + "static/img/15.67a3fb1b.jpg";